'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentOrganizationInfoForm(name, address, certificateOfOriginAuthority) {
  this.yW = null;
  this.Bv = null;
  this.Fl = null;
  this.yW = name;
  this.Bv = address;
  this.Fl = certificateOfOriginAuthority;
}
export { $c_Lapp_data_AppDocumentOrganizationInfoForm as $c_Lapp_data_AppDocumentOrganizationInfoForm };
$p = $c_Lapp_data_AppDocumentOrganizationInfoForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentOrganizationInfoForm;
/** @constructor */
function $h_Lapp_data_AppDocumentOrganizationInfoForm() {
}
export { $h_Lapp_data_AppDocumentOrganizationInfoForm as $h_Lapp_data_AppDocumentOrganizationInfoForm };
$h_Lapp_data_AppDocumentOrganizationInfoForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentOrganizationInfoForm)) {
    if (((this.yW === x$0.yW) && (this.Bv === x$0.Bv))) {
      var x = this.Fl;
      var x$2 = x$0.Fl;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "AppDocumentOrganizationInfoForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.yW;
      break;
    }
    case 1: {
      return this.Bv;
      break;
    }
    case 2: {
      return this.Fl;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "address";
      break;
    }
    case 2: {
      return "certificateOfOriginAuthority";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentOrganizationInfoForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j8)));
}
export { $isArrayOf_Lapp_data_AppDocumentOrganizationInfoForm as $isArrayOf_Lapp_data_AppDocumentOrganizationInfoForm };
var $d_Lapp_data_AppDocumentOrganizationInfoForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentOrganizationInfoForm, "app.data.AppDocumentOrganizationInfoForm", ({
  j8: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentOrganizationInfoForm as $d_Lapp_data_AppDocumentOrganizationInfoForm };
//# sourceMappingURL=app.data.-App-Document-Organization-Info-Form.js.map
